module.exports = __webpack_public_path__ + "img/buddy_snout.70bd201f.svg";